module.exports = __webpack_public_path__ + "media/img/icons/check-icon-lg-f0ce131797360fae44340e83fffa6180.svg";